<template>
    <div class="cc-registration">
        <div class="cc-content cc-content--delivery-address">
            <delivery-address/>
        </div>
        <div class="cc-form-input">
            <input id="user.differentInvoiceAddress" type="checkbox" name="user.differentInvoiceAddress" class="cc-input cc-input--checkbox" :checked="user.differentInvoiceAddress" @change="toggleDifferentInvoiceAddress">
            <label for="user.differentInvoiceAddress" class="cc-label cc-label--checkbox cc-label--important-checkbox">{{ translations['I want an invoice'] }}</label>
        </div>
        <div class="cc-content cc-content--invoice-address" v-if="user.differentInvoiceAddress">
            <invoice-address/>
        </div>
        <div class="cc-form-input" v-if="!isUserLoggedIn">
            <input id="user.requestRegistration" type="checkbox" name="user.requestRegistration" class="cc-input cc-input--checkbox" :checked="user.requestRegistration" @change="toggleRequestRegistration">
            <label for="user.requestRegistration" class="cc-label cc-label--checkbox cc-label--important-checkbox">{{ translations['Request registration'] }}</label>
        </div>
        <div class="cc-form-input" v-if="shouldPasswordBeShown">
            <label for="user.password" class="cc-label cc-label--text">{{ translations['Password'] }}*</label>
            <input id="user.password" type="text" name="user.password" class="cc-input cc-input--text" :value="user.password" @change="updatePassword">
            <div class="cc-alert cc-alert--error" v-if="user.errors.password">{{ user.errors.password }}</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import DeliveryAddress from "./DeliveryAddress";
    import InvoiceAddress from "./InvoiceAddress";

    export default {
        components: {
            DeliveryAddress,
            InvoiceAddress,
        },
        computed: {
            pickupInStore: function () {
                return this.currentCarrier && this.currentCarrier.pickupInStore
            },
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                currentCarrier: state => state.currentCarrier,
                isUserLoggedIn: state => state.isLoggedIn,
            }),
            shouldPasswordBeShown: function () {
                return !this.isUserLoggedIn && this.user.requestRegistration;
            },
        },
        methods: {
            toggleDifferentInvoiceAddress: function (event) {
                this.$store.commit('SET_USER_DIFFERENT_INVOICE_ADDRESS', event.target.checked);
            },
            toggleRequestRegistration: function (event) {
                if (!event.target.checked) {
                    this.$store.commit('SET_USER_PASSWORD', '');
                    this.$store.commit('SET_USER_PASSWORD_ERROR', '');
                }

                this.$store.commit('SET_USER_REQUEST_REGISTRATION', event.target.checked);
            },
            updatePassword: function (event) {
                this.$store.dispatch('UPDATE_PASSWORD', event.target.value);
            },
        },
        name: 'Registration',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-registration {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-content {
            display: block;
            width: 100%;
            max-width: 100%;

            &.cc-content--delivery-address {
                margin-top: 5rem;
            }

            &.cc-content--invoice-address {
                margin-top: 5rem;
            }
        }

        .cc-input {
            &.cc-input--text {
                width: 100%;
            }
        }

        .cc-label {
            &.cc-label--important-checkbox {
                font-size: 16px;
            }
        }
    }
</style>
